module.exports = __webpack_public_path__ + "static/img/interturis-3.a0da738.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/interturis-3.jpg
// module id = qgg5
// module chunks = 1